import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    MediaBox, MediaBoxHeader, MediaBoxBody, MediaBoxTitle, MediaBoxDescription,
    MediaBoxInfoMeta, MediaBoxInfo, Button
} from 'react-weui'
import { WKVisible } from '../../components/wk'
import  { renderMoney }  from '../../utils'
import * as relaycfmAction from '../../actions/relayConfirm'


class RelayConfirmChannel extends React.Component {
    onClickPay (id) {
        this.props.relaycfmPayChannel(id)
    }
    onClickPayFree (id) {
        this.props.relaycfmPostRelayChannel(id)
    }
    handleClick(){
        const channel = this.props.channel
        window.location.href = `/channel/${channel.channel.id}`
    }
    render() {
        const channel = this.props.channel
        if (!channel) return null
        const benefit = this.props.getPercentFee(channel.channel.money, channel.channel.relay_percent)
        return (
            <div className='channel-confirm'>
                <MediaBox type="appmsg" className='margin-bottom' onClick={this.handleClick.bind(this)}>
                    <MediaBoxHeader>
                        <img src={channel.liveroom.avatar_url} alt="" />
                    </MediaBoxHeader>
                    <MediaBoxBody>
                        <MediaBoxTitle>{channel.channel.name}</MediaBoxTitle>
                        <MediaBoxDescription>
                            <span className='small-font'>{channel.liveroom.name || '-'}</span>
                        </MediaBoxDescription>
                        <MediaBoxInfo>
                            <MediaBoxInfoMeta><i className="iconfont icon-erji"></i> {channel.channel.popular}</MediaBoxInfoMeta>
                        </MediaBoxInfo>
                    </MediaBoxBody>
                </MediaBox>
                <div className="pay-box text-center margin-bottom">
                    <p className="big-font">转载该专栏到我的店铺</p>
                    <p className='big-font margin-bottom'>{benefit > 0 ? '可获分成' : '邀请更多好友共享知识盛宴'}</p>
                     <WKVisible create={benefit > 0}>
                        <p className="margin-bottom-double text-minor text-center">
                            <span className="relay-benefit">
                                {benefit}元
                            </span> / 付费用户
                        </p>
                    </WKVisible>
                    {/*<WKVisible create={channel.channel.relay_fee > 0}>
                        <Button size='normal' onClick={e => this.onClickPay(channel.channel.id)}>
                            支付{renderMoney(channel.channel.relay_fee)}元转播
                        </Button>
                    </WKVisible> */}
                    {/* create={channel.channel.relay_fee === 0} */}
                    <WKVisible >
                        <Button onClick={e => this.onClickPayFree(channel.channel.id)} size='normal'>免费转载</Button>
                    </WKVisible>
                </div>
                <div className="padding text-minor">
                    <p className="big-font margin-bottom">关于转载</p>
                    <p>1. 转载付费专栏到自己店铺，有用户购买专栏即可获得分成；</p>
                    <p>2. 转载专栏需要先创建自己的店铺；</p>
                    <p>3. 主店铺的专栏的所有课程都会同步到转载间；</p>
                    <p>4. 转载专栏不支持分销，优惠码，限时特价功能；</p>
                    <p>5. 转载者需要购买专栏，才可收听课程</p>
                </div>
            </div>
        )
    }
}


export default connect(null, dispatch => bindActionCreators({ ...relaycfmAction }, dispatch))(RelayConfirmChannel)



// WEBPACK FOOTER //
// ./src/components/relayConfirm/RelayConfirmChannel.js